import SelectableController from './selectable_controller'
import { escape_html } from 'tom-select/src/utils'
import { TomOption } from 'tom-select/src/types'

interface AuditorUserTomOption extends TomOption {
  name: string
}

export default class extends SelectableController {
  static values = {
    url: { type: String },
    auditorId: { type: String, default: '' }
  }

  declare auditorIdValue: string

  settings = {
    plugins: ['virtual_scroll'],
    preload: false
  }

  connect (): void {
    if (this.element.multiple) {
      this.settings.plugins.push('checkbox_options', 'remove_button')
    }

    super.connect()
  }

  buildUrl (query: string): string {
    const joinOperator = this.urlValue.includes('?') ? '&' : '?'

    return `${this.urlValue}${joinOperator}page=${this.currentPage}&auditor_id=${this.auditorIdValue}` +
      (query === '' ? '' : `&q[name_cont]=${encodeURIComponent(query)}`)
  }

  renderOption (data: AuditorUserTomOption, escape: typeof escape_html): HTMLElement {
    const optionElement = document.createElement('div')
    optionElement.innerHTML = `<div class="option-link"><div class="flex items-center space-x-1.5"><p>${escape(data.name)}</p>`

    return optionElement
  }

  renderItem (data: AuditorUserTomOption, escape: typeof escape_html): HTMLElement {
    const optionElement = document.createElement('div')
    optionElement.innerHTML = '<div class="flex flex-row items-center w-full">' +
      `<p class="max-w-max">${escape(data.name)}</p></div>`

    return optionElement
  }

  changeAuditor ({ detail: { auditorId } }: { detail: { auditorId: string } }): void {
    this.auditorIdValue = auditorId
  }

  auditorIdValueChanged (): void {
    if (this.plugin === undefined) return

    this.plugin.clear(true)
    this.plugin.clearOptions()

    this.currentPage = 1
    this.nothingMoreToLoad = false

    this.plugin.load('')
  }
}
